module.exports = __webpack_public_path__ + "static/media/class-1.d17ba959.PNG";